import { FileMimeType, MaxByteSizeParam } from './types';

interface GetMaxFileSizeParams {
  fileType: FileMimeType;
  maxByteSize: MaxByteSizeParam;
}

export const getMaxFileSize = ({
  fileType,
  maxByteSize,
}: GetMaxFileSizeParams) => {
  if (typeof maxByteSize === 'number') {
    return maxByteSize;
  }

  return maxByteSize[fileType] ?? maxByteSize.default;
};
